import React from 'react'

export function ToggleSwitch({ checked, onChange }: { checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <div className="w-10 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[#5048e5]"></div>
    </label>
  )
}

export function PropertyLabel({ children }: { children: React.ReactNode }) {
  return (
    <label className="text-[11px] font-bold text-slate-500 uppercase tracking-widest">
      {children}
    </label>
  )
}

export function AlignPicker({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const options = [
    { value: 'left', label: 'Left' },
    { value: 'center', label: 'Center' },
    { value: 'right', label: 'Right' },
  ]
  return (
    <div className="flex gap-1">
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`flex-1 py-1.5 rounded-lg border transition-all flex flex-col items-center gap-1 ${
            value === opt.value
              ? 'border-[#5048e5] bg-[#5048e5]/5 text-[#5048e5]'
              : 'border-slate-200 text-slate-400 hover:border-slate-300'
          }`}
        >
          <AlignIcon align={opt.value} />
          <span className="text-[9px] font-bold uppercase tracking-wider">{opt.label}</span>
        </button>
      ))}
    </div>
  )
}

function AlignIcon({ align }: { align: string }) {
  const lines = align === 'left'
    ? [12, 9, 11]
    : align === 'center'
    ? [10, 12, 9]
    : [12, 9, 11]
  const x = align === 'left' ? 1 : align === 'right' ? undefined : undefined
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
      {lines.map((w, i) => {
        const lx = align === 'left' ? 1 : align === 'right' ? 15 - w : (16 - w) / 2
        return (
          <rect key={i} x={lx} y={i * 5} width={w} height={2.5} rx={1} fill="currentColor" />
        )
      })}
    </svg>
  )
}

export function PropertyInput({
  type = 'text',
  value,
  onChange,
  placeholder,
  className = '',
  min,
  max,
}: {
  type?: string
  value: string | number
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  className?: string
  min?: number
  max?: number
}) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      min={min}
      max={max}
      className={`w-full bg-slate-50 border border-slate-200 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-[#5048e5] focus:border-transparent transition-all outline-none ${className}`}
    />
  )
}
